import { removeInvalidPayloadItems, sendCarouselGTMEvent, sendCTAGTMEvent, sendNavigationGTMEvent } from "./gtmEvents";
export const extractNavGTMAttributes = (fields, componentName = undefined) => {
    var _a, _b, _c;
    const { gtmLabel, gtmHeader, gtmComponentType } = fields;
    const gtmFields = {
        'data-gtm-header': (_a = gtmHeader) === null || _a === void 0 ? void 0 : _a.value,
        'data-gtm-label': (_b = gtmLabel) === null || _b === void 0 ? void 0 : _b.value,
        'data-gtm-component-type': ((_c = gtmComponentType) === null || _c === void 0 ? void 0 : _c.value) || componentName
    };
    return removeInvalidPayloadItems(gtmFields) || {};
};
export const extractCTAGTMAttributes = (fields, componentName = undefined) => {
    var _a, _b, _c;
    const { gtmLabel, gtmInteractionType, gtmComponentType } = fields;
    const gtmFields = {
        'data-gtm-interaction-type': (_a = gtmInteractionType) === null || _a === void 0 ? void 0 : _a.value,
        'data-gtm-label': (_b = gtmLabel) === null || _b === void 0 ? void 0 : _b.value,
        'data-gtm-component-type': ((_c = gtmComponentType) === null || _c === void 0 ? void 0 : _c.value) || componentName
    };
    return removeInvalidPayloadItems(gtmFields) || {};
};
export const populateNavigationGTM = (fields, componentName = undefined) => {
    return Object.assign(Object.assign({}, extractNavGTMAttributes(fields, componentName)), { onClick: () => {
            sendNavigationGTMEvent(fields);
        } });
};
export const populateCTAGTM = (fields, componentName = undefined) => {
    return Object.assign(Object.assign({}, extractCTAGTMAttributes(fields, componentName)), { onClick: () => {
            sendCTAGTMEvent(fields);
        } });
};
export const populateGalleryGTM = (isNext) => {
    const interactionType = isNext ? 'next' : 'previous';
    const text = isNext ? 'Right Arrow' : 'Left Arrow';
    const gtmInteractionType = `gallery - view ${interactionType}`;
    const gtmAttributes = {
        'data-gtm-interaction-type': gtmInteractionType,
        'data-gtm-label': text,
        'data-gtm-component-type': 'gallery'
    };
    const data = {
        event: 'cta_click',
        cta_type: gtmInteractionType,
        link_text: text,
        component_type: 'gallery',
        interaction_type: gtmInteractionType
    };
    return {
        gtmAttributes,
        onclick: () => sendCarouselGTMEvent(data)
    };
};
